/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_SubInputs */

const en_mk_build_sub = /** @type {(inputs: Mk_Build_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose what fits your experience. Your plan, progress, and check results stay together in Bystep.`)
};

const id_mk_build_sub = /** @type {(inputs: Mk_Build_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih cara yang sesuai dengan pengalamanmu. Rencana, kemajuan, dan hasil pemeriksaan tetap ada di Bystep.`)
};

/**
* | output |
* | --- |
* | "Choose what fits your experience. Your plan, progress, and check results stay together in Bystep." |
*
* @param {Mk_Build_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_sub = /** @type {((inputs?: Mk_Build_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_sub(inputs)
	return en_mk_build_sub(inputs)
});